angular
.module('app.services')
.service('currentLawyer', [
    '$log', function($log) {
      var selectedLawyer;
      selectedLawyer = {};
      this.setLawyer = function(lawyer) {
        selectedLawyer = lawyer;
      };
      this.getLawyer = function() {
        return selectedLawyer;
      };
    }
]);


// WEBPACK FOOTER //
// ./scripts/shared/services/current-lawyer.js